import dateTimeFormatter from '../../../components/valueFormatter/dateTimeFormatter';
import organizationIdFilterValueGetter from '../../../components/filterValueGetter/organizationIdFilterValueGetter';
import steelMakerFilterValueGetter from '../../../components/filterValueGetter/steelMakerFilterValueGetter';
import businessTypeFilterValueGetter from '../../../components/filterValueGetter/businessTypeFilterValueGetter';
import steelCategoryFilterValueGetter from '../../../components/filterValueGetter/steelCategoryFilterValueGetter';
import updatedByFilterValueGetter from '../../../components/filterValueGetter/updatedByFilterValueGetter';
import createdByFilterValueGetter from '../../../components/filterValueGetter/createdByFilterValueGetter';
import dateFilterComparator from '../../../utils/ag-grid/dateFilterComparator';
import type { ColDef } from 'ag-grid-community';
import type { TFunction } from 'i18next';

const useColdefManageOrganization = (t: TFunction<'translation', undefined>) => {
  const colDefs: ColDef[] = [
    {
      headerName: '',
      colId: 'actions',
      cellRenderer: 'actionsRenderer',
      editable: false,
      filter: false,
      pinned: 'left',
      suppressMenu: true,
      cellStyle: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
      },
      width: 90,
    },
    {
      field: 'organizationBaseId',
      headerName: t('organizationBase.organizationBase'),
      headerTooltip: t('organizationBase.organizationBase'),
      cellRenderer: 'optionsTypeRenderer',
      filterValueGetter: organizationIdFilterValueGetter,
    },
    {
      field: 'organizationSuffixName',
      headerName: t('organization.baseDetail'),
      headerTooltip: t('organization.baseDetail'),
    },
    {
      field: 'steelMaker',
      headerName: t('steelMaker'),
      headerTooltip: t('steelMaker'),
      cellRenderer: 'optionsTypeRenderer',
      filterValueGetter: steelMakerFilterValueGetter,
      minWidth: 180,
      maxWidth: 180,
    },
    {
      field: 'businessType',
      headerName: t('businessType'),
      headerTooltip: t('businessType'),
      cellRenderer: 'optionsTypeRenderer',
      filterValueGetter: businessTypeFilterValueGetter,
      minWidth: 75,
      maxWidth: 75,
    },
    {
      field: 'steelCategory',
      headerName: t('steelCategory'),
      headerTooltip: t('steelCategory'),
      cellRenderer: 'optionsTypeRenderer',
      filterValueGetter: steelCategoryFilterValueGetter,
      minWidth: 100,
      maxWidth: 100,
    },
    {
      field: 'updatedAt',
      headerName: t('grid.updatedAt'),
      headerTooltip: t('grid.updatedAt'),
      filter: 'agDateColumnFilter',
      filterParams: {
        comparator: dateFilterComparator,
      },
      valueFormatter: dateTimeFormatter,
      minWidth: 100,
      maxWidth: 150,
    },
    {
      field: 'updatedBy',
      headerName: t('grid.updatedBy'),
      headerTooltip: t('grid.updatedBy'),
      cellRenderer: 'userNameFromEmailCellRenderer',
      filterValueGetter: updatedByFilterValueGetter,
      minWidth: 100,
      maxWidth: 200,
    },
    {
      field: 'createdAt',
      headerName: t('grid.createdAt'),
      headerTooltip: t('grid.createdAt'),
      filter: 'agDateColumnFilter',
      filterParams: {
        comparator: dateFilterComparator,
      },
      valueFormatter: dateTimeFormatter,
      minWidth: 100,
      maxWidth: 150,
    },
    {
      field: 'createdBy',
      headerName: t('grid.createdBy'),
      headerTooltip: t('grid.createdBy'),
      cellRenderer: 'userNameFromEmailCellRenderer',
      filterValueGetter: createdByFilterValueGetter,
      minWidth: 100,
      maxWidth: 200,
    },
  ];

  return colDefs;
};

export default useColdefManageOrganization;
